import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserTokens } from '../redux/slices/auth.slice';

export const useSyncStorage = () => {
  const dispatch = useDispatch();

  const updateStore = () => {
    try {
      const storeData = localStorage.getItem('persist:root');

      if (!storeData) return;

      const parsedData = JSON.parse(storeData);
      const authString = parsedData?.auth;
      if (!authString) return;

      const auth = JSON.parse(authString);
      if (auth?.userData) {
        dispatch(updateUserTokens(auth.userData));
      }
    } catch (error) {
      console.warn('[useSyncStorage] Failed to parse storage data:', error);
    }
  };

  useEffect(() => {
    window.addEventListener('storage', updateStore);
    return () => window.removeEventListener('storage', updateStore);
  }, []);

  return {};
};
